import { PERMISSIONS } from './permissions';
import {
  Cog6ToothIcon,
  UsersIcon,
  BuildingOfficeIcon,
  ListBulletIcon,
  ComputerDesktopIcon,
  CalendarIcon,
  PencilIcon,
  TicketIcon,
  UserGroupIcon,
  ClockIcon,
  ScissorsIcon,
  SparklesIcon,
  CubeIcon,
  PresentationChartLineIcon
} from '@heroicons/react/24/outline';
import { Sprout } from 'lucide-react';

export const getManagementTabs = t => [
  {
    label: t('nav.generalSettings'),
    to: 'settings',
    permission: PERMISSIONS.GENERAL_SETTINGS,
    icon: Cog6ToothIcon
  },
  { label: t('nav.workers'), to: 'workers', permission: PERMISSIONS.WORKERS, icon: UsersIcon },
  {
    label: t('nav.farmingBlock'),
    to: 'farming-block',
    permission: PERMISSIONS.FARMING_BLOCK,
    icon: BuildingOfficeIcon
  },
  {
    label: t('nav.activities'),
    to: 'activities',
    permission: PERMISSIONS.ACTIVITIES,
    icon: ListBulletIcon
  },
  {
    label: t('nav.devices'),
    to: 'devices',
    permission: PERMISSIONS.DEVICES,
    icon: ComputerDesktopIcon
  },
  { label: t('nav.workday'), to: 'workday', permission: PERMISSIONS.WORKDAY, icon: CalendarIcon },
  {
    label: t('nav.dataEdit'),
    to: 'data-edit',
    permission: PERMISSIONS.DATA_EDIT,
    icon: PencilIcon
  },
  { label: t('nav.stickers'), to: 'stickers', permission: PERMISSIONS.STICKERS, icon: TicketIcon },
  {
    label: t('nav.usersPermissions'),
    to: 'users',
    permission: PERMISSIONS.USERS,
    icon: UserGroupIcon
  },
  { label: t('nav.crops'), to: 'crops', permission: PERMISSIONS.CROPS, icon: Sprout }
];

export const getDashboardTabs = t => [
  {
    label: t('nav.commandCenter'),
    to: 'command-center',
    permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY,
    icon: ComputerDesktopIcon
  },
  {
    label: t('nav.lastWorkingDaySummary'),
    to: 'last-working-day-summary',
    permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY,
    icon: ClockIcon
  },
  {
    label: t('nav.dailyPickSummary'),
    to: 'daily-pick-summary',
    permission: PERMISSIONS.DAILY_PICK_SUMMARY,
    icon: ScissorsIcon
  },
  {
    label: t('nav.dailyAgroSummary'),
    to: 'daily-agro-summary',
    permission: PERMISSIONS.DAILY_AGRO_SUMMARY,
    icon: SparklesIcon
  },
  {
    label: t('nav.dailyPackingSummary'),
    to: 'daily-packing-summary',
    permission: PERMISSIONS.DAILY_PACKING_SUMMARY,
    icon: CubeIcon
  },
  {
    label: t('nav.cropsAnalytics'),
    to: 'cropsAnalytics',
    permission: PERMISSIONS.CROPS,
    icon: PresentationChartLineIcon
  }
];

// Legacy exports for backwards compatibility
export const MANAGEMENT_TABS = [
  {
    label: 'General Settings',
    to: 'settings',
    permission: PERMISSIONS.GENERAL_SETTINGS,
    icon: Cog6ToothIcon
  },
  { label: 'Workers', to: 'workers', permission: PERMISSIONS.WORKERS, icon: UsersIcon },
  {
    label: 'Farming Block',
    to: 'farming-block',
    permission: PERMISSIONS.FARMING_BLOCK,
    icon: BuildingOfficeIcon
  },
  {
    label: 'Activities',
    to: 'activities',
    permission: PERMISSIONS.ACTIVITIES,
    icon: ListBulletIcon
  },
  { label: 'Devices', to: 'devices', permission: PERMISSIONS.DEVICES, icon: ComputerDesktopIcon },
  { label: 'Workday', to: 'workday', permission: PERMISSIONS.WORKDAY, icon: CalendarIcon },
  { label: 'Data Edit', to: 'data-edit', permission: PERMISSIONS.DATA_EDIT, icon: PencilIcon },
  { label: 'Stickers', to: 'stickers', permission: PERMISSIONS.STICKERS, icon: TicketIcon },
  { label: 'Users & Permissions', to: 'users', permission: PERMISSIONS.USERS, icon: UserGroupIcon },
  { label: 'Crops', to: 'crops', permission: PERMISSIONS.CROPS, icon: Sprout }
];

export const DASHBOARD_TABS = [
  {
    label: 'Command Center',
    to: 'command-center',
    permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY,
    icon: ComputerDesktopIcon
  },
  {
    label: 'Last Working Day Summary',
    to: 'last-working-day-summary',
    permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY,
    icon: ClockIcon
  },
  {
    label: 'Daily Pick Summary',
    to: 'daily-pick-summary',
    permission: PERMISSIONS.DAILY_PICK_SUMMARY,
    icon: ScissorsIcon
  },
  {
    label: 'Daily Agro Summary',
    to: 'daily-agro-summary',
    permission: PERMISSIONS.DAILY_AGRO_SUMMARY,
    icon: SparklesIcon
  },
  {
    label: 'Daily Packing Summary',
    to: 'daily-packing-summary',
    permission: PERMISSIONS.DAILY_PACKING_SUMMARY,
    icon: CubeIcon
  },
  // { label: 'Weekly Pick Summary', to: 'weekly-pick-summary', permission: PERMISSIONS.WEEKLY_PICK_SUMMARY },
  // { label: 'Weekly Agro Summary', to: 'weekly-agro-summary', permission: PERMISSIONS.WEEKLY_AGRO_SUMMARY },
  {
    label: 'Crops Analytics',
    to: 'cropsAnalytics',
    permission: PERMISSIONS.CROPS,
    icon: PresentationChartLineIcon
  }
];
